import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Tratamentos do paciente, com cache de leitura offline (via useCachedQuery).
export function useTreatments(patientId) {
  const url = patientId ? `/patients/${patientId}/treatments` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    treatments: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
